import { Box } from "@mui/material";

interface Props {
  score: number;
}

export function SentimentBar({ score }: Props): JSX.Element {
  let color = "";
  let text = "";
  let textColor = "#fff";
  if (score < 1 / 3) {
    color = "#FB5523";
    textColor = "#fff";
    text = "Negative";
  }
  if (score > 1 / 3 && score < 2 / 3) {
    color = "#FDD835";
    text = "Neutral";
    textColor = "#000";
  }
  if (score > 2 / 3) {
    color = "#6DAE43";
    textColor = "#fff";
    text = "Positive";
  }
  return (
    <>
      <Box 
        bgcolor={color} 
        color={textColor} 
        padding="4px 12px"
        borderRadius="4px"
        display="inline-block"
        fontSize="13px"
        fontWeight="500"
        fontFamily="IBM Plex Sans"
      >
        {text}
      </Box>
    </>
  );
}
